﻿// see an example of the base concept here https://css-tricks.com/creating-an-editable-textarea-that-supports-syntax-highlighted-code/
// Interface to allow expando properties without syntax errors (Store code control on main textbox)

/*--- Definition ----------------------------------------------------------------*/
/* Allow clsSyntaxHighlighter to be avialiable in Blazor JSRuntime calls eg js.InvokeAsync("clsSyntaxHighlighter.AddSyntaxHighlighter") 
with out this it will minify into a var like n*/
(window as any).clsSyntaxHighlighter = {
    AddSyntaxHighlighter: AddSyntaxHighlighter,
    RemoveSyntaxHighlighter: RemoveSyntaxHighlighter,
    ChangeScriptType: ChangeScriptType,
    Refresh: Refresh
}
/*--------------------------------------------------------------------------------*/


interface SyntaxTextarea extends HTMLTextAreaElement {
    linkedCodeCtrl?: HTMLElement;
    ScriptType?: eScriptType;
}

export const enum eScriptType {
    None = -1,
    SQL = 0,
    PowerShell = 1
}

let c_clsHighlighter: clsHighlighter | null;
let c_StorePSEscapedCode: clsPSEscapeCode[] | null;

//#region "Add/Remove Control Evetns"
export function AddSyntaxHighlighter(p_strControlID: string, p_eScriptType: eScriptType): void {

    //console.log('AddSyntaxHighlighter');
    const myTextCtrl = document.getElementById(p_strControlID) as SyntaxTextarea;
    const myCodeCtrl = document.getElementById(p_strControlID + "_Code");
    if (myTextCtrl == null || myCodeCtrl == null) { return; }

    // Attach the "Expando" property
    myTextCtrl.linkedCodeCtrl = myCodeCtrl;
    myTextCtrl.ScriptType = p_eScriptType;

    // Attach the listener directly in JS
    myTextCtrl.addEventListener('input', SyntaxHighlighter_Input);

    // Sync scrolling
    myTextCtrl.addEventListener('scroll', SyntaxHighlighter_Scroll);

    c_clsHighlighter = new clsHighlighter();
    switch (p_eScriptType) {
        case eScriptType.SQL:
            LoadSQLSyntax();
            // Run the highligter when first loaded (if there is text)
            if (myTextCtrl.value != "") {
                SyntaxHighlighter_Input.call(myTextCtrl);
            }
            break;

        case eScriptType.PowerShell:
            LoadPowerShellSyntax();
            // Run the highligter when first loaded (if there is text)
            if (myTextCtrl.value != "") {
                SyntaxHighlighter_Input.call(myTextCtrl);
            }
            break;
    }   
}

export function RemoveSyntaxHighlighter(p_strControlID: string): void {

    const myTextCtrl = document.getElementById(p_strControlID) as SyntaxTextarea;
    if (myTextCtrl == null) { return; }

    myTextCtrl.removeEventListener('input', SyntaxHighlighter_Input);
    myTextCtrl.removeEventListener('scroll', SyntaxHighlighter_Scroll);

    // Delete expando properties
    if ('linkedCodeCtrl' in myTextCtrl) {
        delete myTextCtrl.linkedCodeCtrl;
    }
    if ('ScriptType' in myTextCtrl) {
        delete myTextCtrl.ScriptType;
    }

    //c_clsHighlighter?.ClearAllPatterns();
    //c_clsHighlighter = null;
}
//#endregion

// Script type was changed, need to reload the patterns and re-run the highlighter
export function ChangeScriptType(p_strControlID: string, p_eScriptType: eScriptType): void {
    //console.log("Script type changed" + p_eScriptType);

    const myTextCtrl = document.getElementById(p_strControlID) as SyntaxTextarea;
    if (myTextCtrl == null) { return; }

    if (myTextCtrl.ScriptType != p_eScriptType) {
        myTextCtrl.ScriptType = p_eScriptType;

        switch (p_eScriptType) {
            case eScriptType.SQL:
                if (c_clsHighlighter == null) { c_clsHighlighter = new clsHighlighter(); }
                LoadSQLSyntax();
                // Run the highligter again
                if (myTextCtrl.value != "") {
                    SyntaxHighlighter_Input.call(myTextCtrl);
                }
                break;

            case eScriptType.PowerShell:
                if (c_clsHighlighter == null) { c_clsHighlighter = new clsHighlighter(); }
                //console.log("Load power shell");
                LoadPowerShellSyntax();
                // Run the highligter again
                //console.log("tv = " + myTextCtrl.value);
                if (myTextCtrl.value != "") {
                    //console.log("rerender");
                    SyntaxHighlighter_Input.call(myTextCtrl);
                }
                break;

            case eScriptType.None:
                c_clsHighlighter = null;
                break;
        }
    }
}

// Manually trigger the highlighter to re-process the text (after adding a tag in code, etc)
export function Refresh(p_strControlID: string): void {
    const myTextCtrl = document.getElementById(p_strControlID) as SyntaxTextarea;
    if (myTextCtrl == null) { return; }
    SyntaxHighlighter_Input.call(myTextCtrl);
}

//#region "Textbox events"
function SyntaxHighlighter_Scroll(this: SyntaxTextarea): void {

    if (this.linkedCodeCtrl == null) { return; }

    this.linkedCodeCtrl.parentElement!.scrollTop = this.scrollTop;
    this.linkedCodeCtrl.parentElement!.scrollLeft = this.scrollLeft;
}

function SyntaxHighlighter_Input(this: SyntaxTextarea): void {

    if (this.linkedCodeCtrl == null) { return; }
    if (c_clsHighlighter == null) { return; }

    // Escape HTML
    var strHTML = this.value;
    strHTML = strHTML.replace(/&/g, "&amp;").
        replace(/</g, "&lt;").
        replace(/>/g, "&gt;").
        replace(/'/g, "&#39;").
        replace(/"/g, "&quot;")


    var myExpressions: clsExpression[] = c_clsHighlighter.Parse(strHTML);

    var text = '';
    for (const exp of myExpressions) {

        var strCSSClass = "";
        switch (exp.Type) {
            case eExpressionType.Newline:
            case eExpressionType.None:
            case eExpressionType.Whitespace:
                text += exp.Content;
                break;
                
            case eExpressionType.Identifier:
                //#region "case to stop storing for each item"
                //switch (exp.CodeType) {
                //    case eCodeTypes.None:
                //        break;
                //    case eCodeTypes.Comment_multiline:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.Comment:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.String_SingleQuotes:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.String_DoubleQuotes:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.String_DoubleQuotesBeforeEscape:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.String_DoubleQuotesAfterEscape:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.Bracket:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.SquareBracket:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.Keyword:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.Function:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.Expression:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.Type:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.SqiggleBracket:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.HMVariable:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.Commands:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.SQLTableJoin:
                //        strCSSClass = "":
                //        break
                //    case eCodeTypes.SQLVariable:
                //    case eCodeTypes.PSVariable:
                //    case eCodeTypes.PSEscapeString:
                //    case eCodeTypes.PSEscapeString_Start:
                //    case eCodeTypes.PSEscapeString_End:
                //    case eCodeTypes.PSHereString:
                //    case eCodeTypes.PSSplattingHashTable:

                //}
                //#endregion

                if (exp.CSSSyntaxStyleClass == "") {
                    text += exp.Content;
                }
                else
                {
                    text += "<span class='" + exp.CSSSyntaxStyleClass + "'>" + exp.Content + "</span>";
                }
                break;
        }
    }

    // ###############################
    // This need to be last, it is part of the control not the Code syntax
    // 2. Add a trailing newline to prevent "jumping" at the end of the box
    // ###############################
    this.linkedCodeCtrl.innerHTML = text + (text.endsWith('\n') ? ' ' : '');
    
}
//#endregion


// #################################################################################
//#region "old regex only version (worked for SQl, failed for some more complex power shell stuff)"
//function SyntaxHighlighter_Input(this: SyntaxTextarea): void {

//    const text = this.value;
//    //console.log('input ');
//    //console.log(this.linkedCodeCtrl);
//    if (this.linkedCodeCtrl == null) { return; }



//    // Do your Regex work here
//    // 1. Basic SQL Regex (Expand this as needed)
//    //let highlighted = text
//    //    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") // Escape HTML
//    //    .replace(/\b(SELECT|FROM|WHERE|INSERT|UPDATE|DELETE|JOIN|AND|OR|CREATE|TABLE|INTO|VALUES)\b/gi,
//    //        '<span class="sql-keyword">$1</span>')
//    //    .replace(/'(.*?)'/g, '<span class="sql-string">\'$1\'</span>')
//    //    .replace(/--.*$/gm, '<span class="sql-slComment">$&</span>');

//    let highlighted = text;

//    // Escape HTML
//    highlighted = highlighted.replace(/&/g, "&amp;").
//        replace(/</g, "&lt;").
//        replace(/>/g, "&gt;").
//        replace(/'/g, "&#39;").
//        replace(/"/g, "&quot;")


//    // ---------------------------------
//    // SQL
//    // ---------------------------------
//    if (this.ScriptType == eScriptType.SQL) {
//        highlighted = HighLightSQL(text);
//    }
//    // ---------------------------------
//    // Power shell
//    // ---------------------------------
//    else if (this.ScriptType == eScriptType.PowerShell) {
//        highlighted = HighLightPowerShell(text);
//    }

//    // ###############################
//    // This need to be last, it is part of the control not the Code syntax
//    // 2. Add a trailing newline to prevent "jumping" at the end of the box
//    // ###############################
//    this.linkedCodeCtrl.innerHTML = highlighted + (text.endsWith('\n') ? ' ' : '');

//}

//#region "// HighLight SQL"
//function HighLightSQL(strText: string) : string {

//    // Needs to be first so doesn't replace ' in the built spans HTML
//    // single quote strings (also allows '' in the string to not stop it)
//    //highlighted = highlighted.replace(/\'([^']|\'\')*\'/gi, "<span class='sql-string'>\'$1\'</span>");
//    //highlighted = highlighted.replace(/\'([^']|\'\')*\'/gi, "<span class='sql-string'>$&</span>");
//    strText = strText.replace(/&\#39;(?:[^]|&\#39;&\#39;)*&\#39;/gi, "<span class='sql-string'>$&</span>");



//    // multi-line comments eg(/* comments */ the start /* and end can be spread over multiple lines)
//    strText = strText.replace(/\/\*(.|[\r\n])*?\*\//g, "<span class='sql-mlComment'>$&</span>");

//    // single-line comments
//    strText = strText.replace(/--.*$/gm, "<span class='sql-slComment'>$&</span>");

//    // HelpMaster Variables <<Tag>>. NOTE: replace << with single ⟪, so below code looking for less than < etc don;t replace them again (they then get replaces right at the bottom)
//    strText = strText.replace(/&lt;&lt;(\w+)&gt;&gt;/gi, "<span class='sql-HMTag'>⟪$1⟫</span>");

//    // parentheses ( And )
//    strText = strText.replace("(", "<span class='sql-Bracket'>(</span>");
//    strText = strText.replace(")", "<span class='sql-Bracket'>)</span>");

//    // SquareBracket
//    strText = strText.replace(/\[[^\]]+\]/g, "<span class='sql-SqBracket'>$&</span>");

//    // Multi word Joins
//    // Have this before the one below that adds "Join" as a purple function name Or "LEFT OUTER JOIN" will show join in purple
//    strText = strText.replace(/\b(Inner Join|Left Outer Join|Right Outer Join|Full Outer Join|Cross Join|Natural Join)\b/gi, "<span class='sql-TableJoin'>$&</span>");

//    // keywords
//    strText = strText.replace(/\b(SELECT|FROM|WHERE|GROUP BY|HAVING|ORDER BY|ON|AS|IF|For|BETWEEN|DISTINCT|TOP|LIMIT|OFFSET|FETCH|NEXT|ROW|ROWS|ONLY|WITH|TIES|UNION|ALTER|CREATE|VIEW|Declare|Delete|WHILE|OPEN|CLOSE|INTO|BEGIN|END|SET|DEALLOCATE|CURSOR|Print|PROCEDURE|TABLE|View|Use|Go|First|CHECK|CONSTRAINT|ADD|PRIMARY|Key|CLUSTERED|Asc|desc|FOREIGN|KEY|REFERENCES|CASE|When|Then|Else|MILLISECOND|GOTO|INSERT|VALUES|OVER|PARTITION|BY|Return|QUOTED_IDENTIFIER|ANSI_NULLS)\b/gi, "<span class='sql-Keyword'>$&</span>");

//    // Functions
//    strText = strText.replace(/\b(UPDATE|MAX|MIN|\@\@FETCH_STATUS|IsNull|DATEDIFF|GETUTCDATE|GETDATE|ABS|CEILING|FLOOR|ROUND|SQRT|POWER|LEN|LOWER|UPPER|SUBSTRING|TRIM|CAST|COALESCE|NULLIF|DATEPART|DATEADD|DateName|IsDate|row_number|ISNUMERIC|ASCII|CHAR|CHARINDEX|CONCAT|LEFT|LTRIM|REPLACE|PATINDEX|REVERSE|RIGHT|RTRIM|SOUNDEX|SPACE|STR|STUFF|TRANSLATE|UNICODE|\@\@ROWCOUNT|second|MINUTE|hour|day|month|year|week|weekday)\b/gi, "<span class='sql-Function'>$&</span>");

//    // Expressions
//    //highlighted = highlighted.replace(/\b(IN|=|;|,|\.|\/|Null|AND|OR|NOT|IS|LIKE|>|<|\+|\-|\&|\||\^|\*|PIVOT)\b/gi, "<span class='sql-Expression'>$&</span>");
//    strText = strText.replace(/\b(IN|Null|AND|OR|NOT|IS|LIKE|PIVOT)\b/gi, "<span class='sql-Expression'>$&</span>");
//    //highlighted = highlighted.replace(/(^|[^A-Za-z0-9_])(;|,|\.|\/|\+|\-|\&|\||\^|\*|\<|\>)(?=$|[^A-Za-z0-9_])/g, "$1<span class='sql-Expression'>$2</span>");
//    strText = strText.replace(/(^|[^A-Za-z0-9_<&])(,|\.|-|\+|\*|\/|=|&lt;&gt;|!=|&lt;=|&gt;=|&gt;|&lt;)(?=$|[^A-Za-z0-9_])/g, "$1<span class='sql-Expression'>$2</span>");

//    // Types
//    strText = strText.replace(/\b(int|Sting|DateTime|varchar|nvarchar|money|bigint|binary|varbinary|bit|char|date|datetime2|datetimeoffset|smalldatetime|Time|decimal|date|float|geography|xml|image|nchar|text|ntext|numeric|smallint|smallmoney|timestamp|uniqueidentifier)\b/gi, "<span class='sql-Type'>$&</span>");

//    // @SQL Variables
//    strText = strText.replace(/@\w+/gi, "<span class='sql-SQLVariable'>$&</span>");


//    // Fix stand in replace chars
//    strText = strText.replace(/⟪/gi, "&lt;&lt;").replace(/⟫/gi, "&gt;&gt;");

//    return strText;
//}
//#endregion

//#region "// HighLight Power Shell"
//function HighLightPowerShell(strText: string): string {

//    // power shell splatting (hash tables)
//    strText = strText.replace(/@\[\s\S]*?\}/g, "<span class='ps-HashTable'>$&</span>");

//    // Multi-line comment <# comment #>
//    //highlighted = highlighted.replace(/\<\#(.|[\r\n])*?\#\>/g, "<span class='ps-mlComment'>$&</span>");
//    strText = strText.replace(/&lt;\#(.|[\r\n])*?\#&gt;/g, "<span class='ps-mlComment'>$&</span>");

//    // single-line comments
//    strText = strText.replace(/\#.*?$/g, "<span class='ps-Comment'>$&</span>");

//    // Powershell escape code in strings
//    // eg.  $(code)
//    // NOTE: this regex not supported by TS, need to do it in code
//    //highlighted = highlighted.replace(/(\$\((?>(?<DEPTH>\()|(?<-DEPTH>\))|[^\(\)]+)*\))(?(DEPTH)(?!))/g, "<span class='ps-EscapeString'>$&</span>");
//    strText = highlightDollarExpressions(strText);

//    // Powershell here-string
//    // eg. @"This is a here - string. It can contain "double quotes" or 'single quotes' without escaping them.
//    //     It can also span multiple lines."@
//    strText = strText.replace(/@\"\n[\s\S]*?\n\"@/g, "<span class='ps-HereString'>$&</span>");
//    // Same as above with single quotes
//    strText = strText.replace(/@'\n[\s\S]*?\n'@/g, "<span class='ps-HereString'>$&</span>");

//    // Expressions
//    //console.log("test before " + highlighted);
//    strText = strText.replace(/(^|[^A-Za-z0-9_<&])(=|;|,|\.|\/|&gt;|&lt;|\+|\-|&amp;|\||\^|\*|!)(?=$|[^A-Za-z0-9_])/g, "$1<span class='ps-Expressions'>$2</span>");
//    //console.log("test after " + highlighted);
//    strText = strText.replace(/\b(Null|AND|OR|NOT)\b/gi, "<span class='ps-Expressions'>$&</span>");

//    // Double quote strings (also allows "" in the string to Not stop it)
//    //highlighted = highlighted.replace(/\""([^\""]|\""\"")*\""/g, "<span class='ps-DoubleQuotes'>$&</span>");
//    //highlighted = highlighted.replace(/&quot;"([^&quot;"]|&quot;"&quot;")*\""/g, "<span class='ps-DoubleQuotes'>$&</span>");
//    //highlighted = highlighted.replace(/"(""|[^"])*"/g, "<span class='ps-DoubleQuotes'>$&</span>");
//    strText = strText.replace(/&quot;(?:&quot;&quot;|(?!&quot;).)*&quot;/g, "<span class='ps-DoubleQuotes'>$&</span>");
//    //console.log("test dquote " + highlighted);

//    // single quote strings (also allows '' in the string to not stop it)
//    //highlighted = highlighted.replace(/\'([^']|\'\')*\'/g, "<span class='ps-SingleQuotes'>$&</span>");
//    strText = strText.replace(/&#39;(&#39;&#39;|[^&#39;])*&#39;/g, "<span class='ps-SingleQuotes'>$&</span>");
//    //highlighted = highlighted.replace(/&\#39;(?:&\#39;&\#39;|(?!&\#39;).)*&\#39;/g, "<span class='ps-SingleQuotes'>$&</span>");
//    //highlighted = highlighted.replace(/&\#39;(?:[^]|&\#39;&\#39;)*&\#39;/gi, "<span class='ps-SingleQuotes'>$&</span>");
//    //console.log("test dquote " + highlighted);

//    // HelpMaster Variables <<Tag>>
//    strText = strText.replace(/&lt;&lt;(\w+)&gt;&gt;/gi, "<span class='ps-HMTag'>$&</span>");

//    // Types
//    strText = strText.replace(/\b(function|$null|\[DateTime\]|\[int\]|\[long\]|\[uint\]|\[ulong\]|\[char\]|\[string\]|\[Decimal\]|\[Double\]|\[Single\]|\[float\]|\[bool\]|\[Boolean\]|\[Array\]|\[Hashtable\]|\[psobject\]|\[pscustomobject\])\b/gi, "<span class='ps-Types'>$&</span>");

//    // Keywords
//    strText = strText.replace(/\b(try|if|foreach|in|exit|catch|param|for)\b/gi, "<span class='ps-Keywords'>$&</span>");

//    // Commands
//    strText = strText.replace(/\b(Add-Type|Invoke-RestMethod|access_token|New-Item|Rename-Item|Remove-Item|Get-Content|Get-Process|Stop-Process|Read-Host|Write-Host|Get-Date|Write-Output|Get-Random)\b/gi, "<span class='ps-Commands'>$&</span>");

//    // $Variables (hash-table)
//    //highlighted = highlighted.replace(/\$\w+/gi, "<span class='ps-Variables'>$&</span>");
//    strText = strText.replace(/(?<!&)\$\w+/gi, "<span class='ps-Variables'>$&</span>");

//    // @Variables (Post-splat)
//    strText = strText.replace(/\@\w+/gi, "<span class='ps-VariablesPS'>$&</span>");

//    // Expressions
//    //console.log("test before " + highlighted);
//    //highlighted = highlighted.replace(/(^|[^A-Za-z0-9_<&])(=|;|,|\.|\/|&gt;|&lt;|\+|\-|&amp;|\||\^|\*|!)(?=$|[^A-Za-z0-9_])/g, "<span class='ps-Expressions'>$&</span>");
//    //highlighted = highlighted.replace(/(^|[^A-Za-z0-9_<&])(=|;|,|\.|\/|&gt;|&lt;|\+|\-|&amp;|\||\^|\*|!)(?=$|[^A-Za-z0-9_])/g, "$1<span class='ps-Expressions'>$2</span>");
//    //highlighted = highlighted.replace(/(?<!ps-DoubleQuotes[^>]*>)(^|[^A-Za-z0-9_<&])(=|;|,|\.|\/|&gt;|&lt;|\+|\-|&amp;|\||\^|\*|!)(?=$|[^A-Za-z0-9_])/g, "$1<span class='ps-Expressions'>$2</span>");
//    //console.log("test after " + highlighted);
//    //highlighted = highlighted.replace(/\b(Null|AND|OR|NOT)\b/gi, "<span class='ps-Expressions'>$&</span>");

//    // parentheses ( And )
//    //highlighted = highlighted.replace("(", "<span class='ps-Bracket'>(</span>");
//    //highlighted = highlighted.replace(")", "<span class='ps-Bracket'>)</span>");

//    // parentheses [ And ]
//    strText = strText.replace("[", "<span class='ps-SquareBracket'>(</span>");
//    strText = strText.replace("]", "<span class='ps-SquareBracket'>)</span>");

//    // parentheses { And }
//    strText = strText.replace("{", "<span class='ps-SqiggleBracket'>(</span>");
//    strText = strText.replace("}", "<span class='ps-SqiggleBracket'>)</span>");

//    return strText;
//}
//#endregion

//#region "// Dollar Expressions"
//function highlightDollarExpressions(text: string): string {

//    if (!text.includes("$(")) {
//        return text;
//    }

//    //const matches = matchDollarExpressions(text);
//    const ranges = findDollarExpressions(text);

//    // Sort by start ASC
//    ranges.sort((a, b) => a.start - b.start);

//    let result = "";
//    let i = 0;
//    let rIndex = 0;
//    const stack: { start: number; end: number }[] = [];

//    while (i < text.length) {
//        const r = ranges[rIndex];

//        if (r && i === r.start) {
//            stack.push(r);

//            // emit "$("
//            result += "<span class='ps-EscapeStringDol'>$</span>";
//            result += "<span class='ps-EscapeString'>(</span>";
//            i += 2; // skip "$("

//            rIndex++;
//            continue;
//        }

//        // Closing ")"
//        if (stack.length > 0) {
//            const top = stack[stack.length - 1];

//            if (i === top.end - 1) {
//                result += `<span class='ps-EscapeString'>)</span>`;
//                stack.pop();
//                i++;
//                continue;
//            }
//        }

//        // normal character
//        result += text[i];
//        i++;
//    }

//    return result;
//}

//function findDollarExpressions(code: string): { start: number; end: number }[] {
//    const ranges: { start: number; end: number }[] = [];
//    const stack: number[] = [];

//    for (let i = 0; i < code.length; i++) {
//        // detect "$("
//        if (code[i] === '$' && code[i + 1] === '(') {
//            stack.push(i);
//            i++; // skip '('

//        } else if (code[i] === ')' && stack.length > 0) {
//            const start = stack.pop()!;
//            const end = i + 1; // include ')'
//            ranges.push({ start, end });
//        }
//    }

//    // sort inner → outer so replacements don’t disturb indices
//    //ranges.sort((a, b) => b.start - a.start);
//    console.log(ranges);
//    return ranges;
//}
//#endregion

//function matchDollarExpressions(text: string): { start: number, end: number }[] {
//    const matches = [];
//    let i = 0;

//    while (i < text.length) {
//        if (text[i] === '$' && text[i + 1] === '(') {
//            let start = i;
//            i += 2;

//            let depth = 1;

//            while (i < text.length && depth > 0) {
//                if (text[i] === '(') depth++;
//                else if (text[i] === ')') depth--;
//                i++;
//            }

//            if (depth === 0) {
//                matches.push({ start, end: i });
//            }
//        } else {
//            i++;
//        }
//    }

//    return matches;
//}
//#endregion
// #################################################################################

//#region "Dollar Expressions"
function getOuterPowerShellDollarExpressions(code: string) {

    const ranges: { start: number; end: number }[] = [];
    let depth = 0;
    let startIdx = -1;

    let inSingleQuote = false;
    let inDoubleQuote = false;
    let inComment = false;

    for (let i = 0; i < code.length; i++) {
        const char = code[i];
        const nextChar = code[i + 1];
        const prevChar = code[i - 1];

        // 1. Handle Comments (End of line)
        if (inComment) {
            if (char === '\n') inComment = false;
            continue;
        }

        // 2. Handle Strings (Escaping in PS is backtick ` or doubled quotes "")
        if (inSingleQuote) {
            // End of single quote (check for doubled '' which is an escaped quote)
            if (char === "'" && nextChar === "'") { i++; continue; }
            if (char === "'") inSingleQuote = false;
            continue;
        }

        if (inDoubleQuote) {
            // Handle escaped double quotes `" or ""
            if (char === '`' && nextChar === '"') { i++; continue; }
            if (char === '"' && nextChar === '"') { i++; continue; }

            // NOTE: $( is actually valid inside double quotes in PS.
            // If you want to find sub-expressions INSIDE double quotes, 
            // we allow the logic to fall through here.
            if (char === '"') {
                inDoubleQuote = false;
                continue;
            }
        }

        // 3. Start State Detection
        if (!inDoubleQuote && !inSingleQuote) {
            if (char === '#') {
                inComment = true;
                continue;
            }
            if (char === "'") {
                inSingleQuote = true;
                continue;
            }
        }

        if (char === '"' && !inSingleQuote) {
            inDoubleQuote = true;
            // We don't "continue" because the very next char could be $(
        }

        // 4. The Nesting Logic (Only runs if not in comment or single-quote)
        if (char === '$' && nextChar === '(') {
            if (depth === 0) startIdx = i;
            depth++;
            i++; // skip '('
        } else if (char === '(' && depth > 0) {
            depth++;
        } else if (char === ')' && depth > 0) {
            depth--;
            if (depth === 0) {
                ranges.push({ start: startIdx, end: i + 1 });
                startIdx = -1;
            }
        }
    }

    return ranges;
}

function getOuterPowerShellSplattingHashTables(code: string) {

    const ranges: { start: number; end: number }[] = [];
    let depth = 0;
    let startIdx = -1;

    let inSingleQuote = false;
    let inDoubleQuote = false;
    let inComment = false;

    for (let i = 0; i < code.length; i++) {
        const char = code[i];
        const nextChar = code[i + 1];
        const prevChar = code[i - 1];

        // 1. Handle Comments (End of line)
        if (inComment) {
            if (char === '\n') inComment = false;
            continue;
        }

        // 2. Handle Strings (Escaping in PS is backtick ` or doubled quotes "")
        if (inSingleQuote) {
            // End of single quote (check for doubled '' which is an escaped quote)
            if (char === "'" && nextChar === "'") { i++; continue; }
            if (char === "'") inSingleQuote = false;
            continue;
        }

        if (inDoubleQuote) {
            // Handle escaped double quotes `" or ""
            if (char === '`' && nextChar === '"') { i++; continue; }
            if (char === '"' && nextChar === '"') { i++; continue; }

            // NOTE: $( is actually valid inside double quotes in PS.
            // If you want to find sub-expressions INSIDE double quotes, 
            // we allow the logic to fall through here.
            if (char === '"') {
                inDoubleQuote = false;
                continue;
            }
        }

        // 3. Start State Detection
        if (!inDoubleQuote && !inSingleQuote) {
            if (char === '#') {
                inComment = true;
                continue;
            }
            if (char === "'") {
                inSingleQuote = true;
                continue;
            }
        }

        if (char === '"' && !inSingleQuote) {
            inDoubleQuote = true;
            // We don't "continue" because the very next char could be $(
        }

        // 4. The Nesting Logic (Only runs if not in comment or single-quote)
        if (char === '@' && nextChar === '{') {
            if (depth === 0) startIdx = i;
            depth++;
            i++; // skip '{'
        } else if (char === '{' && depth > 0) {
            depth++;
        } else if (char === '}' && depth > 0) {
            depth--;
            if (depth === 0) {
                ranges.push({ start: startIdx, end: i + 1 });
                startIdx = -1;
            }
        }
    }

    return ranges;
}
//#endregion

//#region "Load SQL Syntax"
function LoadSQLSyntax() {

    if (c_clsHighlighter == null) { return; }

    // Clear any current styles
    c_clsHighlighter.ClearAllPatterns();

    // multi-line comments eg(/* comments */ the start /* and end can be spread over multiple lines)
    c_clsHighlighter.AddPattern("Comment-multiline", eCodeTypes.Comment_multiline,
        new clsPatternDefinition(/\/\*(.|[\r\n])*?\*\//gm), "sql-mlComment");

    // single-line comments
    c_clsHighlighter.AddPattern("Comment", eCodeTypes.Comment,
        new clsPatternDefinition(/--.*?$/gm), "sql-slComment");

    // single quote strings (also allows '' in the string to not stop it)
    //c_clsHighlighter.AddPattern("String", eCodeTypes.String_SingleQuotes,
    //    new clsPatternDefinition(/&\#39;(?:[^]|&\#39;&\#39;)*&\#39;/gi), "sql-string");
    c_clsHighlighter.AddPattern("String", eCodeTypes.String_SingleQuotes,
        new clsPatternDefinition(/&#39;(?:[^&#39;]|&#39;&#39;)*&#39;/gi), "sql-string");

    // HelpMaster Variables <<Tag>>. 
    // NOTE: replace << with single ⟪, so below code looking for less than < etc don't replace them again (they then get replaces right at the bottom)
    c_clsHighlighter.AddPattern("HMVariableTag", eCodeTypes.HMVariable,
        new clsPatternDefinition(/&lt;&lt;(\w+)&gt;&gt;/gi), "sql-HMTag");

    // parentheses ( And )
    c_clsHighlighter.AddPattern("Bracket", eCodeTypes.Bracket,
        new clsPatternDefinition(/[()]/g), "sql-Bracket"); ///\b(\(|\))\b/gi

    // parentheses [ And ]
    c_clsHighlighter.AddPattern("SquareBracket", eCodeTypes.SquareBracket,
        new clsPatternDefinition(/(\[|\]|\(|\))/g), "sql-SqBracket"); // /\[[^\]]+\]/gi

    // parentheses { And }
    c_clsHighlighter.AddPattern("Bracket", eCodeTypes.Bracket,
        new clsPatternDefinition(/[{}]/g), "sql-Bracket"); ///\b(\(|\))\b/gi

    // Multi word Joins
    // Have this before the one below that adds "Join" as a purple function name Or "LEFT OUTER JOIN" will show join in purple
    c_clsHighlighter.AddPattern("TableJoin", eCodeTypes.SQLTableJoin,
        new clsPatternDefinition(/\b(Inner Join|Left Outer Join|Right Outer Join|Full Outer Join|Cross Join|Natural Join)\b/gi),
        "sql-TableJoin");

    // Keywords
    c_clsHighlighter.AddPattern("Keyword", eCodeTypes.Keyword,
        new clsPatternDefinition(/\b(SELECT|FROM|WHERE|GROUP BY|HAVING|ORDER BY|ON|AS|IF|For|BETWEEN|DISTINCT|TOP|LIMIT|OFFSET|FETCH|NEXT|ROW|ROWS|ONLY|WITH|TIES|UNION|ALTER|CREATE|VIEW|Declare|Delete|WHILE|OPEN|CLOSE|INTO|BEGIN|END|SET|DEALLOCATE|CURSOR|Print|PROCEDURE|TABLE|View|Use|Go|First|CHECK|CONSTRAINT|ADD|PRIMARY|Key|CLUSTERED|Asc|desc|FOREIGN|KEY|REFERENCES|CASE|When|Then|Else|MILLISECOND|GOTO|INSERT|VALUES|OVER|PARTITION|BY|Return|QUOTED_IDENTIFIER|ANSI_NULLS)\b/gi),
        "sql-Keyword");

    // Functions
    c_clsHighlighter.AddPattern("Function", eCodeTypes.Function,
        new clsPatternDefinition(/\b(UPDATE|MAX|MIN|\@\@FETCH_STATUS|IsNull|DATEDIFF|GETUTCDATE|GETDATE|COUNT|ABS|CEILING|FLOOR|ROUND|SQRT|POWER|LEN|LOWER|UPPER|SUBSTRING|TRIM|CAST|COALESCE|NULLIF|DATEPART|DATEADD|DateName|IsDate|row_number|ISNUMERIC|ASCII|CHAR|CHARINDEX|CONCAT|LEFT|LTRIM|REPLACE|PATINDEX|REVERSE|RIGHT|RTRIM|SOUNDEX|SPACE|STR|STUFF|TRANSLATE|UNICODE|\@\@ROWCOUNT|second|MINUTE|hour|day|month|year|week|weekday)\b/gi),
        "sql-Function");

    // Expressions
    c_clsHighlighter.AddPattern("Expression", eCodeTypes.Expression,
        new clsPatternDefinition(/\b(IN|Null|AND|OR|NOT|IS|LIKE|PIVOT)\b/gi),
        "sql-Expression");
    //c_clsHighlighter.AddPattern("Expression", eCodeTypes.Expression,
    //    new clsPatternDefinition(/(^|[^A-Za-z0-9_<&])(,|\.|-|\+|\*|\/|=|&lt;&gt;|!=|&lt;=|&gt;=|&gt;|&lt;)(?=$|[^A-Za-z0-9_])/g),
    //    "sql-Expression");
    c_clsHighlighter.AddPattern("Expression", eCodeTypes.Expression,
        new clsPatternDefinition(/(^|[^A-Za-z0-9_<&;&])(,|\.|-|\+|\*|\/|=|&lt;&gt;|!=|&lt;=|&gt;=|&gt;|&lt;)(?=$|[^A-Za-z0-9_])/g),
        "sql-Expression");

    // Types
    c_clsHighlighter.AddPattern("Type", eCodeTypes.Type,
        new clsPatternDefinition(/\b(int|Sting|DateTime|varchar|nvarchar|money|bigint|binary|varbinary|bit|char|date|datetime2|datetimeoffset|smalldatetime|Time|decimal|date|float|geography|xml|image|nchar|text|ntext|numeric|smallint|smallmoney|timestamp|uniqueidentifier)\b/gi),
        "sql-Type");

    // @SQL Variables
    c_clsHighlighter.AddPattern("VariableSQL", eCodeTypes.SQLVariable,
        new clsPatternDefinition(/@\w+/gi),
        "sql-SQLVariable");
           
}
//#endregion

//#region "Load PowerShell Syntax"
function LoadPowerShellSyntax() {

    if (c_clsHighlighter == null) { return; }

    // Clear any current styles
    c_clsHighlighter.ClearAllPatterns();

    // power shell splatting (hash tables)
    c_clsHighlighter.AddPattern("PSSplattingHashTable", eCodeTypes.PSSplattingHashTable,
        new clsPatternDefinition(/@\{[\s\S]*?\}/g),
        "ps-HashTable");

    // Multi-line comment <# comment #>
    c_clsHighlighter.AddPattern("CommentMultiline", eCodeTypes.Comment_multiline,
        new clsPatternDefinition(/&lt;\#(.|[\r\n])*?\#&gt;/g),
        "ps-mlComment");

    // single-line comments
    //c_clsHighlighter.AddPattern("Comment", eCodeTypes.Comment,
    //    new clsPatternDefinition(/\#.*?$/gm),
    //    "ps-Comment");
    c_clsHighlighter.AddPattern("Comment", eCodeTypes.Comment,
        new clsPatternDefinition(/(?<!&#?)#.*?$/gm),
        "ps-Comment");

    // Powershell escape code in strings
    // NOTE: this regex not supported by TS, need to do it in code
    //highlightDollarExpressions2();
    c_clsHighlighter.AddPattern("PSEscapeString", eCodeTypes.PSEscapeString,
        new clsPatternDefinition(/$\(\(\(\(\)\)\)\)/g), ""); // NOTE: this is not a real regex its a place holder to call the findDollarExpressions function later

    // Powershell here-string (using ")
    c_clsHighlighter.AddPattern("PSHereString", eCodeTypes.PSHereString,
        new clsPatternDefinition(/@&quot;\n[\s\S]*?\n&quot;@/g),
        "ps-HereString");
    // Same as above with single quotes
    c_clsHighlighter.AddPattern("PSHereString2", eCodeTypes.PSHereString,
        new clsPatternDefinition(/@&#39;\n[\s\S]*?\n&#39;@/g),
        "ps-HereString");

    // Double quote strings (also allows "" in the string to Not stop it)
    //c_clsHighlighter.AddPattern("StringDoubleQuotes", eCodeTypes.String_DoubleQuotes,
    //    new clsPatternDefinition(/&quot;(?:&quot;&quot;|(?!&quot;).)*&quot;/g),
    //    "ps-DoubleQuotes");
    c_clsHighlighter.AddPattern("StringDoubleQuotes", eCodeTypes.String_DoubleQuotes,
        new clsPatternDefinition(/&quot;(?:&quot;&quot;|`&quot;|(?!&quot;)[\s\S])*&quot;/g),
        "ps-DoubleQuotes");

    // single quote strings (also allows '' in the string to not stop it)
    c_clsHighlighter.AddPattern("StringSingleQuotes", eCodeTypes.String_SingleQuotes,
        new clsPatternDefinition(/&#39;(&#39;&#39;|[^&#39;])*&#39;/g),
        "ps-SingleQuotes");

    // HelpMaster Variables <<Tag>>
    c_clsHighlighter.AddPattern("HMVariableTag", eCodeTypes.HMVariable,
        new clsPatternDefinition(/&lt;&lt;(\w+)&gt;&gt;/gi),
        "ps-HMTag");

    // Types
    c_clsHighlighter.AddPattern("Type", eCodeTypes.Type,
        new clsPatternDefinition(/\b(function|$null|\[DateTime\]|\[int\]|\[long\]|\[uint\]|\[ulong\]|\[char\]|\[string\]|\[Decimal\]|\[Double\]|\[Single\]|\[float\]|\[bool\]|\[Boolean\]|\[Array\]|\[Hashtable\]|\[psobject\]|\[pscustomobject\])\b/gi),
        "ps-Types");

    // Keywords
    c_clsHighlighter.AddPattern("Keyword", eCodeTypes.Keyword,
        new clsPatternDefinition(/\b(try|if|foreach|in|exit|catch|param|for)\b/gi),
        "ps-Keywords");

    // Commands
    c_clsHighlighter.AddPattern("Command", eCodeTypes.Commands,
        new clsPatternDefinition(/\b(Add-Type|Invoke-RestMethod|access_token|New-Item|Rename-Item|Remove-Item|Get-Content|Get-Process|Stop-Process|Read-Host|Write-Host|Get-Date|Write-Output|Get-Random)\b/gi),
        "ps-Commands");

    // $Variables (hash-table)
    c_clsHighlighter.AddPattern("VariablePS", eCodeTypes.PSVariable,
        new clsPatternDefinition(/(?<!&)\$\w+/gi),
        "ps-VariablesPS");

    // @Variables (Post-splat)
    c_clsHighlighter.AddPattern("VariablePS@", eCodeTypes.PSVariable,
        new clsPatternDefinition(/\@\w+/gi),
        "ps-VariablesPS");

    // Expressions
    c_clsHighlighter.AddPattern("Expression@", eCodeTypes.Expression,
        new clsPatternDefinition(/(^|[^A-Za-z0-9_<&])(=|;|,|\.|\/|&gt;|&lt;|\+|\-|&amp;|\||\^|\*|!)(?=$|[^A-Za-z0-9_])/g),
        "ps-Expressions");
    c_clsHighlighter.AddPattern("Expression@", eCodeTypes.Expression,
        new clsPatternDefinition(/\b(Null|AND|OR|NOT)\b/gi),
        "ps-Expressions");

    // parentheses ( And )
    c_clsHighlighter.AddPattern("Bracket", eCodeTypes.Bracket,
        new clsPatternDefinition(/\(|\)/gi),
        "ps-Bracket");

    // parentheses [ And ]
    c_clsHighlighter.AddPattern("SquareBracket", eCodeTypes.SquareBracket,
        new clsPatternDefinition(/[|]/gi),
        "ps-SquareBracket");

    // parentheses { And }
    c_clsHighlighter.AddPattern("SqiggleBracket", eCodeTypes.SqiggleBracket,
        new clsPatternDefinition(/[{|}]/gi),
        "ps-SqiggleBracket");
}
//#endregion

class clsHighlighter {

    private _patternStyles: clsPatternStyleMap[] = []; 
  
    ClearAllPatterns() {
        this._patternStyles.length = 0; // quick clear (recommended)
        //this._patternStyles = []; // full clear
    }

    AddPattern(name: string, codeType: eCodeTypes, patternDefinition: clsPatternDefinition, syntaxStyle: string) {
        this._patternStyles.push(new clsPatternStyleMap(name, codeType, patternDefinition, syntaxStyle));
    }

    Parse(text: string): clsExpression[] {

        c_StorePSEscapedCode = [];

        var parsedExpressions: clsExpression[] = [];
        parsedExpressions.push(new clsExpression(text, eCodeTypes.None, eExpressionType.None, "", "")); 

        for (const psm of this._patternStyles) {
            parsedExpressions = this.ParsePattern(psm, parsedExpressions);
        }
                
        // PS escaped code in strings
        // Need to run the parser on the escaped string parts
        do {
            var inPSEscapeCodeCount = c_StorePSEscapedCode.length;
            if (c_StorePSEscapedCode.length > 0) {
                parsedExpressions = this.ProcessPSEscapedCode(parsedExpressions);

                if (c_StorePSEscapedCode.length == inPSEscapeCodeCount) {
                    // all processed
                    c_StorePSEscapedCode.length = 0; // Clear 
                    break;
                }
                else {
                    // call to ProcessPSEscapedCode found another escape string process it as well
                    // by looping again
                }
            }
            else {
                // No PSEsacpe codes exit loop
                break;
            }
        } while (true);

        c_StorePSEscapedCode.length = 0; // Clear 

        parsedExpressions = this.ProcessLineBreaks(parsedExpressions);
        return parsedExpressions;

    }

    ProcessLineBreaks(expressions: clsExpression[]): clsExpression[] {

        var parsedExpressions: clsExpression[] = [];
        var myRegex: RegExp = /\r?\n/g;

        for (const inputExpression of expressions) {
            var lastProcessedIndex = -1;

            const matches = Array.from(inputExpression.Content.matchAll(myRegex))
                .sort((a, b) => (a.index ?? 0) - (b.index ?? 0));

            for (const myMatch of matches) {
                if (myMatch.index > lastProcessedIndex + 1) {
                    var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, myMatch.index - lastProcessedIndex - 1);
                    var nonMatchedExpression = new clsExpression(nonMatchedContent, inputExpression.CodeType, inputExpression.Type, inputExpression.Group, inputExpression.CSSSyntaxStyleClass);
                    parsedExpressions.push(nonMatchedExpression);
                }

                var matchedContent: string = this.StringPart(inputExpression.Content, myMatch.index, myMatch[0].length);
                var matchedExpression = new clsExpression(matchedContent, inputExpression.CodeType, eExpressionType.Newline, "line-break", "");
                parsedExpressions.push(matchedExpression);
                lastProcessedIndex = myMatch.index + myMatch[0].length - 1;
            }

            if (lastProcessedIndex < inputExpression.Content.length - 1) {
                var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                var nonMatchedExpression = new clsExpression(nonMatchedContent, inputExpression.CodeType, inputExpression.Type, inputExpression.Group, inputExpression.CSSSyntaxStyleClass);
                parsedExpressions.push(nonMatchedExpression);
            }
               
        }

        return parsedExpressions;

    }

    //#region "Parse Pattern"
    ParsePattern(patternStyleMap: clsPatternStyleMap, expressions: clsExpression[]): clsExpression[] {

        var parsedExpressions: clsExpression[] = [];

        //if (patternStyleMap.CodeType == eCodeTypes.Function) {
        //    var a = 1;
        //}

        for (const inputExpression of expressions) {

            if (inputExpression.Type != eExpressionType.None) {
                let blnAddAsIs: boolean = true;

                // --------------------------------------------------------------------------
                // Allow finding tags in SQL strings
                // --------------------------------------------------------------------------
                if (inputExpression.CodeType == eCodeTypes.String_SingleQuotes) {
                    if (patternStyleMap.CodeType == eCodeTypes.HMVariable) {
                        // Allow finding tags in SQL strings
                        var myRegex: RegExp = patternStyleMap.PatternDefinition._regex;
                        var lastProcessedIndex: number = -1;

                        const matches = Array.from(inputExpression.Content.matchAll(myRegex))
                            .sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
                            // C# For Each myMatch As Match In myRegex.Matches(inputExpression.Content).Cast(Of Match)().OrderBy(Function(m) m.Index)

                        for (const myMatch of matches) {
                            // Start of String
                            if (myMatch.index > lastProcessedIndex + 1) {
                                var strContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, myMatch.index - lastProcessedIndex - 1);
                                var myStartStringExpression = new clsExpression(strContent, eCodeTypes.String_SingleQuotes, inputExpression.Type, inputExpression.Group, inputExpression.CSSSyntaxStyleClass);
                                parsedExpressions.push(myStartStringExpression);
                            }
                            
                            // HM Tag
                            var strHMTag: string = this.StringPart(inputExpression.Content, myMatch.index, myMatch[0].length);
                            var matchedExpression = new clsExpression(strHMTag, eCodeTypes.HMVariable, patternStyleMap.PatternDefinition._expressionType, patternStyleMap.Name, patternStyleMap.CSSSyntaxStyleClass);
                            parsedExpressions.push(matchedExpression);
                            lastProcessedIndex = myMatch.index + myMatch[0].length - 1;
                        }

                        // End of string (NOTE: this is in the correct spot as it is end of string after multiple matches above may be found)
                        if (lastProcessedIndex < inputExpression.Content.length - 1) {
                            var strContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                            var myEndStringExpression = new clsExpression(strContent, eCodeTypes.String_SingleQuotes, inputExpression.Type, inputExpression.Group, inputExpression.CSSSyntaxStyleClass);
                            parsedExpressions.push(myEndStringExpression);
                        }

                        blnAddAsIs = false;
                    }
                }

                // -----------------------------------------------------------------
                // Standard if no special code above
                // -----------------------------------------------------------------
                if (blnAddAsIs == true) {
                    parsedExpressions.push(inputExpression);
                }
            }
            else {
                var myRegex = patternStyleMap.PatternDefinition._regex;
                var lastProcessedIndex = -1;

                switch (patternStyleMap.CodeType) {
                    case eCodeTypes.PSEscapeString:
                        {
                            var strPSEscapeStringReplaced = "";
                            // -------------------------------------------------------------------
                            // Powershell escape strings
                            // -------------------------------------------------------------------

                            //####################################################
                            // New Type script code
                            //####################################################
                            const ranges = getOuterPowerShellDollarExpressions(inputExpression.Content);

                            // Sort by start ASC
                            if (ranges.length > 0) {
                                ranges.sort((a, b) => a.start - b.start);

                                for (const range of ranges) {
                                    var strBefore: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, range.start - lastProcessedIndex - 1);
                                    var PSEscapreCode: string = inputExpression.Content.substring(range.start, range.end);
                                    lastProcessedIndex = range.end - 1;

                                    var strKey: string = "#PSescapeCODE" + c_StorePSEscapedCode!.length.toString() + "#";
                                    // build up code to store as one expression at end
                                    strPSEscapeStringReplaced += strBefore + strKey;
                                    // store escaped PS code
                                    c_StorePSEscapedCode!.push(new clsPSEscapeCode(strKey, PSEscapreCode));
                                }
                            }

                            // Add any code at end
                            if (lastProcessedIndex < inputExpression.Content.length - 1) {
                                var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                                strPSEscapeStringReplaced += nonMatchedContent;
                            }

                            // Join together multiple bits of code with no CodeType now "Powershell escape strings" are stored separately
                            var nonMatchedExpression = new clsExpression(strPSEscapeStringReplaced, eCodeTypes.None, eExpressionType.None, "", "");
                            parsedExpressions.push(nonMatchedExpression);

                            //####################################################
                            // Old C# Code
                            // REgex needed is not supported in TypeScript
                            //####################################################
                            //const matches = Array.from(inputExpression.Content.matchAll(myRegex))
                            //    .sort((a, b) => (a.index ?? 0) - (b.index ?? 0));
                            ////For Each match As Match In myRegex.Matches(inputExpression.Content).Cast(Of Match)().OrderBy(Function(m) m.Index)

                            //for (const match of matches) {
                            //    var strBefore: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, match.index - lastProcessedIndex - 1);
                            //    var PSEscapreCode: string = this.StringPart(inputExpression.Content, match.index, match[0].length);
                            //    lastProcessedIndex = match.index + match[0].length - 1;

                            //    var strKey: string = "#PSescapeCODE" + c_StorePSEscapedCode!.length.toString() + "#";
                            //    // build up code to store as one expression at end
                            //    strPSEscapeStringReplaced += strBefore + strKey;
                            //    // store escaped PS code
                            //    c_StorePSEscapedCode!.push(new clsPSEscapeCode(strKey, PSEscapreCode));
                            //}

                            //// Add any code at end
                            //if (lastProcessedIndex < inputExpression.Content.length - 1) {
                            //    var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                            //    strPSEscapeStringReplaced += nonMatchedContent;
                            //}

                            //// Join together multiple bits of code with no CodeType now "Powershell escape strings" are stored separately
                            //var nonMatchedExpression = new clsExpression(strPSEscapeStringReplaced, eCodeTypes.None, eExpressionType.None, "", "");
                            //parsedExpressions.push(nonMatchedExpression);
                        }
                        break;

                    case eCodeTypes.PSSplattingHashTable:
                        {

                            //####################################################
                            // New Type script code
                            //####################################################
                            var strPSHashTableStringReplaced = "";
                            const ranges = getOuterPowerShellSplattingHashTables(inputExpression.Content);

                            // Sort by start ASC
                            if (ranges.length > 0) {
                                ranges.sort((a, b) => a.start - b.start);

                                for (const range of ranges) {
                                    var strBefore: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, range.start - lastProcessedIndex - 1);
                                    var PSEscapreCode: string = inputExpression.Content.substring(range.start, range.end);
                                    lastProcessedIndex = range.end - 1;

                                    var strKey: string = "#PSescapeCODE" + c_StorePSEscapedCode!.length.toString() + "#";
                                    // build up code to store as one expression at end
                                    strPSHashTableStringReplaced += strBefore + strKey;
                                    // store escaped PS code
                                    c_StorePSEscapedCode!.push(new clsPSEscapeCode(strKey, PSEscapreCode));
                                }
                            }

                            // Add any code at end
                            if (lastProcessedIndex < inputExpression.Content.length - 1) {
                                var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                                strPSHashTableStringReplaced += nonMatchedContent;
                            }

                            // Join together multiple bits of code with no CodeType now "Powershell escape strings" are stored separately
                            var nonMatchedExpression = new clsExpression(strPSHashTableStringReplaced, eCodeTypes.None, eExpressionType.None, "", "");
                            parsedExpressions.push(nonMatchedExpression);


                            //####################################################
                            // Old C# Code
                            // didn;t do nested hash tables in regex
                            //####################################################
                            //const matches = Array.from(inputExpression.Content.matchAll(myRegex))
                            //    .sort((a, b) => (a.index ?? 0) - (b.index ?? 0));

                            //for (const match of matches) {
                            //    if (match.index > lastProcessedIndex + 1) {
                            //        // -------------------------------------------------------------------
                            //        // Add code before match
                            //        // -------------------------------------------------------------------
                            //        var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, match.index - lastProcessedIndex - 1)
                            //        var BeforeExpression = new clsExpression(nonMatchedContent, eCodeTypes.None, eExpressionType.None, "", "");
                            //        parsedExpressions.push(BeforeExpression);
                            //    }

                            //    // -------------------------------------------------------------------
                            //    // Matched Code 
                            //    // -------------------------------------------------------------------
                            //    var matchedContent: string = this.StringPart(inputExpression.Content, match.index + 2, match[0].length - 3); // remove the @{ from start And } from end

                            //    var parsedExpressions2: clsExpression[] = [];
                            //    parsedExpressions2.push(new clsExpression(matchedContent, eCodeTypes.None, eExpressionType.None, "", "")); 

                            //    for (const patternStyleMap2 of this._patternStyles) {
                            //        parsedExpressions2 = this.ParsePattern(patternStyleMap2, parsedExpressions2);
                            //    }
                                 
                            //    //Add the start of the escape
                            //    // PSEscapeString_Start = "$" - color Blue (uses "Type" group to get the existing blue color)
                            //    var PSEscapeStart = new clsExpression("@", eCodeTypes.PSEscapeString_Start, eExpressionType.Identifier, "Type", "ps-EscapeStringDol");
                            //    // type Is used as it has blue color
                            //    parsedExpressions.push(PSEscapeStart);
                            //    // PSEscapeString_Start =  ")" - color yellow
                            //    PSEscapeStart = new clsExpression("{", eCodeTypes.PSEscapeString_Start, eExpressionType.Identifier, "PSEscapeString", "ps-EscapeString");
                            //    parsedExpressions.push(PSEscapeStart)

                            //    // Add the collection of formatted code expressions
                            //    for (const exp of parsedExpressions2) {
                            //        parsedExpressions.push(exp);
                            //    }


                            //    // PSEscapeString_End =  ")" - color yellow
                            //    var PSEscapeEnd = new clsExpression("}", eCodeTypes.PSEscapeString_End, eExpressionType.Identifier, "PSEscapeString", "ps-EscapeString");
                            //    parsedExpressions.push(PSEscapeEnd);

                            //    // ------------------------------------------------------------------
                            //    // Store current index for next match/end of string
                            //    // ------------------------------------------------------------------
                            //    lastProcessedIndex = match.index + match[0].length - 1;
                            //}

                            //// -------------------------------------------------------------------
                            //// Add any code after the match (Or all code if no match)
                            //// -------------------------------------------------------------------
                            //if (lastProcessedIndex < inputExpression.Content.length - 1) {
                            //    var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                            //    var AfterExpression = new clsExpression(nonMatchedContent, eCodeTypes.None, eExpressionType.None, "", "");
                            //    parsedExpressions.push(AfterExpression);
                            //}
                        }
                        break;

                    default:
                        // Normal code
                        const matches = Array.from(inputExpression.Content.matchAll(myRegex))
                            .sort((a, b) => (a.index ?? 0) - (b.index ?? 0));

                        //if (patternStyleMap.CodeType == eCodeTypes.Comment) {
                        //    console.log(myRegex);
                        //    console.log(matches);
                        //}

                        for (const match of matches) {                            
                            if (match.index > lastProcessedIndex + 1) {
                                // -------------------------------------------------------------------
                                // Add code before match
                                // -------------------------------------------------------------------
                                var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, match.index - lastProcessedIndex - 1);
                                var BeforeExpression = new clsExpression(nonMatchedContent, eCodeTypes.None, eExpressionType.None, "", "");
                                parsedExpressions.push(BeforeExpression);
                            }

                            // -------------------------------------------------------------------
                            // Matched Code (Add normally)
                            // -------------------------------------------------------------------
                            var matchedContent: string = this.StringPart(inputExpression.Content, match.index, match[0].length);
                            var matchedExpression = new clsExpression(matchedContent, patternStyleMap.CodeType, patternStyleMap.PatternDefinition._expressionType, patternStyleMap.Name, patternStyleMap.CSSSyntaxStyleClass);
                            parsedExpressions.push(matchedExpression);
                            lastProcessedIndex = match.index + match[0].length - 1;
                        }

                        // -------------------------------------------------------------------
                        // Add any code after the match (Or all code if no match)
                        // -------------------------------------------------------------------
                        if (lastProcessedIndex < inputExpression.Content.length - 1) {
                            var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                            var AfterExpression = new clsExpression(nonMatchedContent, eCodeTypes.None, eExpressionType.None, "", "");
                            parsedExpressions.push(AfterExpression);
                        }
                        break;
                }
            }
        }
                
        return parsedExpressions;
    }
    //#endregion

    // Make a function that works like c# ie substring(start, length), not typescripts substring(start, end)
    StringPart(p_strText: string, start: number, length: number): string {
        return p_strText.slice(start, start + length);
    }

    //#region "ProcessPSEscapedCode"
    ProcessPSEscapedCode(expressions: clsExpression[]): clsExpression[] {

        var parsedExpressions: clsExpression[] = [];

        for (const inputExpression of expressions) {
        
            if (inputExpression.Content.includes("#PSescapeCODE")) {

                // ------------------------------------------------------------------
                // Found the escape code
                // ------------------------------------------------------------------
                var lastProcessedIndex = -1;

                // Clone the list as ParsePattern adds to _StorePSEscapedCode and causes a "System.InvalidOperationException: 'Collection was modified; " error
                // using this power sheel as an example
                // $val1 = $(Get-Date)
                // $val2 = $(1 + 2)
                // $val3 = $(Write-Output $(Get-Random))
                // $val4 = $(Invoke-RestMethod -Uri "https://example.com/api?x=$(Get-Random)")
                //Dim myTempCollection As List(Of PSEscapeCode) = _StorePSEscapedCode.ToList() // NOTE: No error is typescript (just won't include new items)

                for (const myEscapeCode of c_StorePSEscapedCode!) {

                    var intWhere = inputExpression.Content.indexOf(myEscapeCode.KeyName);
                    if (intWhere > -1) {
                                                
                        // ------------------------------------------------------------------
                        // Start of String (Or start of string after last match)
                        // ------------------------------------------------------------------
                        if (intWhere > lastProcessedIndex + 1) {
                            var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, intWhere - lastProcessedIndex - 1);
                            var myStartStringExpression = new clsExpression(nonMatchedContent, eCodeTypes.String_DoubleQuotesBeforeEscape, inputExpression.Type, inputExpression.Group, inputExpression.CSSSyntaxStyleClass);
                            parsedExpressions.push(myStartStringExpression);
                        }

                        // ------------------------------------------------------------------
                        // Parse the powershell code by itself
                        // ------------------------------------------------------------------
                        var strPSCode: string = myEscapeCode.Code;
                        var matchedContent: string = this.StringPart(strPSCode, 2, strPSCode.length - 3); // remove the $( from start And ) from End

                        var parsedExpressions2: clsExpression[] = [];
                        parsedExpressions2.push(new clsExpression(matchedContent, eCodeTypes.None, eExpressionType.None, "", "")); 
                        
                        for (const patternStyleMap2 of this._patternStyles) {
                            
                            parsedExpressions2 = this.ParsePattern(patternStyleMap2, parsedExpressions2);
                        }

                        var strSymbol = "";
                        var strStartBracket = "";
                        var strEndBracket = "";
                        if (strPSCode.startsWith("$(")) {
                            // EscapeString
                            strSymbol = "$";
                            strStartBracket = "(";
                            strEndBracket = ")";
                        }
                        else if (strPSCode.startsWith("@{")) {
                            // Hashtable
                            strSymbol = "@";
                            strStartBracket = "{";
                            strEndBracket = "}";
                        }


                        // Add the start of the escape
                        // PSEscapeString_Start = "$" - color Blue (uses "Type" group to get the existing blue color)
                        var PSEscapeStart = new clsExpression(strSymbol, eCodeTypes.PSEscapeString_Start, eExpressionType.Identifier, "Type", "ps-EscapeStringDol" );
                        // type Is used as it has blue color
                        parsedExpressions.push(PSEscapeStart);
                        // PSEscapeString_Start =  ")" - color yellow
                        PSEscapeStart = new clsExpression(strStartBracket, eCodeTypes.PSEscapeString_Start, eExpressionType.Identifier, "PSEscapeString", "ps-EscapeString");
                        parsedExpressions.push(PSEscapeStart);

                        // Add the collection of formatted code expressions
                        for (const exp of parsedExpressions2) {
                            parsedExpressions.push(exp);
                        }


                        // PSEscapeString_End =  ")" - color yellow
                        var PSEscapeEnd = new clsExpression(strEndBracket, eCodeTypes.PSEscapeString_End, eExpressionType.Identifier, "PSEscapeString", "ps-EscapeString");
                        parsedExpressions.push(PSEscapeEnd);

                        // ------------------------------------------------------------------
                        // Store current index for next match/end of string
                        // ------------------------------------------------------------------
                        lastProcessedIndex = intWhere + myEscapeCode.KeyName.length - 1;
                    }
                }

                // ------------------------------------------------------------------
                // Add any code at end
                // ------------------------------------------------------------------
                if (lastProcessedIndex < inputExpression.Content.length - 1) {
                    var nonMatchedContent: string = this.StringPart(inputExpression.Content, lastProcessedIndex + 1, inputExpression.Content.length - lastProcessedIndex - 1);
                    var nonMatchedExpression = new clsExpression(nonMatchedContent, eCodeTypes.String_DoubleQuotesAfterEscape, inputExpression.Type, inputExpression.Group, inputExpression.CSSSyntaxStyleClass);
                    parsedExpressions.push(nonMatchedExpression);
                }

            }
            else {

                // ------------------------------------------------------------------
                // Add expression as Is (Not a PS escape code part)
                // ------------------------------------------------------------------
                parsedExpressions.push(inputExpression);
            }
        }

        return parsedExpressions;

    }
    //#endregion

} // class clsHighlighter

//#region "Classes and enums"
const enum eExpressionType {
    None = 0,
    Identifier = 1,
    Whitespace = 2,
    Newline = 3
}

const enum eCodeTypes {
    None = 0,
    Comment_multiline = 1,
    Comment = 2,
    // String_SingleQuotes_blank = 3 ' '' or "", etc colors like string but no content
    // String_DoubleQuotes_blank = 4
    String_SingleQuotes = 5,
    String_DoubleQuotes = 6,
    String_DoubleQuotesBeforeEscape = 7,
    String_DoubleQuotesAfterEscape = 8,
    Bracket = 9,
    SquareBracket = 10,
    Keyword = 11,
    Function = 12,
    Expression = 13,
    Type = 14,
    SqiggleBracket = 15,
    HMVariable = 20,
    Commands = 21,

    SQLTableJoin = 30,
    SQLVariable = 31,

    PSVariable = 50,
    PSEscapeString = 51, // the escaped PS code eg $(code)
    PSEscapeString_Start = 52, // before parsing the escaped part
    PSEscapeString_End = 53, // after parsing the escaped part
    // PSEscapeInnerCode = 54
    PSHereString = 54,
    PSSplattingHashTable = 55
}

class clsPSEscapeCode {
    KeyName: string;
    Code: string;

    constructor(KeyName: string, Code: string) {
        this.KeyName = KeyName;
        this.Code = Code;
    }
}

class clsExpression {
    Type: eExpressionType;
    Content: string;
    Group: string;
    CodeType: eCodeTypes;
    CSSSyntaxStyleClass: string;

    constructor(Content: string, CodeType: eCodeTypes, Type: eExpressionType, Group: string, CSSSyntaxStyleClass: string) {
        this.Type = Type;
        this.Content = Content;
        this.Group = Group;
        this.CodeType = CodeType;
        this.CSSSyntaxStyleClass = CSSSyntaxStyleClass;
    }
}
class clsPatternStyleMap {
    Name: string;
    PatternDefinition: clsPatternDefinition;
    CSSSyntaxStyleClass: string;
    CodeType: eCodeTypes;

    constructor(Name: string, CodeType: eCodeTypes, PatternDefinition: clsPatternDefinition, SyntaxStyle: string) {
        this.Name = Name;
        this.CodeType = CodeType; 
        this.PatternDefinition = PatternDefinition;
        this.CSSSyntaxStyleClass = SyntaxStyle;
    }
}

class clsPatternDefinition {
    _regex: RegExp;
    _expressionType: eExpressionType;
    _isCaseSensitive: boolean = true;

    constructor(regex: RegExp, expressionType: eExpressionType = eExpressionType.Identifier, _isCaseSensitive: boolean = true) {
        this._regex = regex;
        this._expressionType = expressionType;
        this._isCaseSensitive = _isCaseSensitive;
    }

    //static FromTokens(isCaseSensitive: boolean, tokens: string[]): clsPatternDefinition {
    //    _isCaseSensitive = isCaseSensitive;
    //    for (const token of tokens) {
    //    { 
    //        //Dim escaptedToken As String = Regex.Escape(token.Trim())

    //            If escaptedToken.Length > 0 Then

    //                If Char.IsLetterOrDigit(escaptedToken(0)) Then
    //    regexTokens.Add(String.Format("\b{0}\b", escaptedToken))
    //    Else
    //    regexTokens.Add(escaptedToken)
    //                End If
    //            End If
    //    }

    //        Dim pattern As String = String.Join("|", regexTokens)
    //        Dim regexOptions As RegexOptions = RegexOptions.Compiled
    //        If Not caseSensitive Then regexOptions = regexOptions Or regexOptions.IgnoreCase
    //    _regex = New Regex(pattern, regexOptions)
    //} 
}

//class clsStyleGroupPair {
//    Index: number;
//    SyntaxStyle: clsSyntaxStyle;
//    GroupName: string;
//}
//#endregion
